import React from 'react';

import ErrorComponent from '../../components/Error';

import { useApi } from '../../utils/hooks';

import Photo from '../../assets/bunker.jpg';
import '../../utils/styles/Bunker.css';

function Bunker() {
    const { data, loading, error } = useApi('bunker-schools/');

    // Display the error message if the request fails
    if (loading) return <div className="container">Chargement...</div>;

    // Display a loading message while the request is pending
    if (error) return <ErrorComponent title="Error" errorObject={error} />;

    const lastDocument =
        data.results && data.results.length > 0
            ? data.results[data.results.length - 1]
            : null;

    return (
        <>
            <div id="bunker-header">
                <img src={Photo} alt="bunker" />
                <div id="bunker-header-title">
                    <p className="title-2">Le Bunker</p>
                    <p className="subtitle">
                        Le Bunker de Namur est un espace de soirée réservé aux
                        étudiant·e·s du supérieur.
                    </p>
                </div>
            </div>
            <div className="container">
                <div className="content">
                    <p className="title">Réservations en ligne</p>
                    <p className="paragraph">
                        Il est maintenant possible de réserver ta prévente directement en ligne afin de limiter les files et faciliter l'accès au Bunker.
                        Rendez-vous ici :{' '}
                        <a href="https://www.age-namur.be/events" target="_blank" rel="noopener noreferrer">
                            https://www.age-namur.be/events
                        </a>
                    </p>
                </div>
                <div className="content">
                    <p className="title">Localisation</p>
                    <p className="paragraph">
                        Le Bunker se situe au sous-sol de la Faculté de
                        Médecine. L'accès se fait par la Place du Palais de
                        Justice où se trouveront des files d'attente afin que
                        les gardes puissent vérifier ta prévente et ta carte
                        étudiante.
                    </p>
                </div>
                <div className="content">
                    <p className="title">Conditions d'accès</p>
                    <p className="paragraph">
                    Tous les étudiant·e·s inscrit·e·s dans une université, 
                    une haute école ou une école supérieure figurant dans 
                    la liste des établissements autorisés (voir ci-dessous) 
                    peuvent entrer au Bunker, à condition de présenter 
                    leur prévente et leur carte étudiante avec photo. 
                    Pour toute question à ce sujet, n'hésitez pas 
                    à contacter l'AGE par <a href="mailto:age@unamur.be">e-mail</a>.<br />

                        {lastDocument && (
                            <a
                                className="bunker-schools-link"
                                href={lastDocument.schools}
                            >
                                Liste des établissements autorisés
                            </a>
                        )}
                    </p>
                </div>
                <div className="content">
                    <p className="title">Guide de survie</p>
                    <ol>
                        <li>Mets ta prévente à l'avance.</li>
                        <li>Prends ta carte étudiante.</li>
                        <li>
                            N'oublie pas ton ecocup (ou prévois 1.20€ en plus).
                        </li>
                        <li>Mets-toi dans la bonne file :</li>
                        <ul>
                            <li>Droite -{'>'} étudiant UNamur</li>
                            <li>Gauche -{'>'} externe</li>
                        </ul>
                        <li>Pense à boire de l'eau, c'est gratuit !</li>
                        <li>
                            Amuse-toi (tout en faisant attention à toi et à tes
                            potes).
                        </li>
                        <li>Ne rentre jamais seul·e.</li>
                        <li>N'oublie pas ta tenue de ville (ou tes bottes).</li>
                    </ol>
                </div>
                <div>
                    <strong className="paragraph">
                        Vente ou achat de prévente au-delà de 5€ strictement
                        interdit, sous peine d'être blacklisté.
                    </strong>
                </div>
            </div>
        </>
    );
}

export default Bunker;
